<template>
  <div>
    <div class="display-images-wrapper">
      <div class="brand-info">
        <h2>{{displayName}}</h2>
        <p>{{description}}</p>
          <div v-if="brandSelected">
            <p class="submitted" v-if="supplyUpdated">inventory request submitted</p>
            <button v-else @click="clickedMarketAction(brandDisplayId, 'inventory_requests')" class="button inventory">low on supply? click here to notify</button>
            <p class="submitted" v-if="sponsorUpdated">sponsored request submitted</p>
            <button v-else @click="clickedMarketAction(brandDisplayId, 'sponsor_requests')" class="button sponsor">sponsor my campaign</button>
            <p class="error" v-if="errorMessage">{{errorMessage}}</p>
          </div>
      </div>

      <div class="images-container fade-gradient-bottom">
        <div class="main-image">
          <img class="main-img" :src="dynamicMainBrandImg" alt="main-img">
        </div>
        <section>
          <div :class="{ activated: dynamicMainBrandImgId === activeImageId }" class="side-images" @click="activeImageId = dynamicMainBrandImgId">
            <img :src="demoImg" alt="side-img" @click="clickedSideImg(demoImg)">
          </div>
          <div class="side-images"
            :key="index"
            v-for="(image, index) in secondaryImages"
            :class="{ activated: image.id === activeImageId }"
                @click="activeImageId = image.id">
            <img @click="clickedSideImg(image.url)" :src="image.url" alt="side-img">
          </div>
        </section>
      </div>
    </div>

    <modal
      v-if="showModal && isMobile && loaded"
      wrapperClasses="brand-info-modal"
      :showClose="true"
      @close="closeModal">
      <div slot="body" class="body">
        <h2>{{displayName}}</h2>
        <carousel :slides="mobileSlides.slides" />
        <p v-if="supplyUpdated" class="submitted">inventory request submitted</p>
        <button v-else @click="clickedMarketAction(brandDisplayId, 'inventory_requests')" class="button inventory">low on supply? click here to notify</button>
        <p v-if="sponsorUpdated" class="submitted">sponsored request submitted</p>
        <button v-else @click="clickedMarketAction(brandDisplayId, 'sponsor_requests')" class="button sponsor">sponsor my campaign</button>
        <p v-if="errorMessage" class="error">{{errorMessage}}</p>
        <div>
          <p>{{description}}</p>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
 import { brandsMarketplaceAPI } from "../../services/api/brandsMarketplace"
 import { parseISO, isToday } from 'date-fns'
 import { Carousel } from '@springbig/sb-components'
 import Modal from '../shared/Modal'

  export default {
    props: {
      marketplaceDisplay: Object,
      isMobile: Boolean,
      showModal: Boolean
    },

    components: {
      Modal,
      Carousel
    },

    name: 'BrandsMarketplaceDisplay',

    data() {
      return {
        dynamicMainBrandImg: null,
        dynamicMainBrandImgId: null,
        displayName: null,
        description: null,
        demoImg: null,
        secondaryImages: null,
        activeImageId: null,
        supplyUpdated: false,
        sponsorUpdated: false,
        brandsLoading: false,
        brandDisplayId: null,
        brandSelected: null,
        errorMessage: null,
        merchantInventoryDate: null,
        merchantSponsorDate: null,
        mobileSlides: {},
        loaded: false
      }
    },

    methods: {
      configureDisplay(display) {
        if (display.hasOwnProperty('last_merchant_sponsor_request_at')) {
          this.brandSelected = true
        } else {
          this.brandSelected = false
        }

        this.demoImg = display.primary_image.url
        this.displayName = display.name
        this.description = display.description
        this.dynamicMainBrandImg = display.primary_image.url
        this.secondaryImages = display.secondary_images
        this.dynamicMainBrandImgId = display.primary_image.id
        this.activeImageId = display.primary_image.id
        this.brandDisplayId = display.id
        this.merchantInventoryDate = display.last_merchant_inventory_request_at
        this.merchantSponsorDate = display.last_merchant_sponsor_request_at

        let inventoryResult = isToday(parseISO(this.merchantInventoryDate))
        let sponsorResult = isToday(parseISO(this.merchantSponsorDate))

        if (inventoryResult) {
          this.supplyUpdated = true
        } else {
          this.supplyUpdated = false
        }

        if (sponsorResult) {
          this.sponsorUpdated = true
        } else {
          this.sponsorUpdated = false
        }

        if (this.isMobile && this.showModal) {
          this.createSlidesArray('mobileSlides', display.secondary_images)
        }

        this.loaded = true
      },

      createSlidesArray(dataProp, arr) {
        let carousel = {
          slides: []
        }

        arr.forEach((element) => {
          carousel.slides.push({
            label: null,
            imgSrc: element.url,
            id: element.id,
            createdAt: null
          })
        })

        carousel.slides.unshift({
          label: null,
          imgSrc: this.dynamicMainBrandImg,
          id: this.dynamicMainBrandImgId,
          createdAt: null
        })

        this[dataProp] = carousel
      },

      closeModal() {
        this.$emit('closeModal')
        this.loaded = false
      },

      clickedSideImg(url) {
        this.dynamicMainBrandImg = url
      },

      async clickedMarketAction(id, actionType) {
        this.brandsLoading = true
        try {
          const marketActionRequest = await brandsMarketplaceAPI.postMarketplaceAction({brand_display_id: id, action_type: actionType})
          if (actionType === 'inventory_requests') {
            this.supplyUpdated = true
          } else {
            this.sponsorUpdated = true
          }
        } catch (error) {
          this.errorMessage = error
        }
        this.brandsLoading = false
      }
    },

    created() {
      !!this.marketplaceDisplay && this.configureDisplay(this.marketplaceDisplay)
    },

    watch: {
      marketplaceDisplay: function () {
        !!this.marketplaceDisplay && this.configureDisplay(this.marketplaceDisplay)
      }
    }
  }
</script>

<style scoped>
  .images-container .activated {
    border: 2px solid #128ff9;
  }

  .images-container .main-img {
    width: 600px;
    height: 280px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border: 2px solid #128ff9;
  }

  .images-container .side-images {
    cursor: pointer;
  }

  .images-container .main-img {
    position: relative;
    z-index: -1;
  }

  /* important needed  to override body .button  */
  .brand-info .inventory {
    margin-top: 25px !important;
  }

  .brand-info .sponsor,
  .brand-info .inventory {
    width: 255px;
    font-weight: 400;
    font-family: 'AileronThin';
  }

  .display-images-wrapper .submitted {
    color: limegreen;
    font-weight: 600;
    margin-top: 10px;
    font-size: 18px;
    width: auto;
  }

  .display-images-wrapper p.submitted:first-child {
    margin-top: 20px;
  }

  .brand-info .error {
    color: red;
    font-weight: 600;
  }
</style>
